import { createPaginatedSlice } from "../../../helpers/reduxHelper";

const paginatedSharedProductPage = createPaginatedSlice('paginatedSharedProductPage');

export const paginatedSharedProductPageActions = paginatedSharedProductPage.actions
export const paginatedSharedProductPageSelector = state => state.paginatedSharedProductPage;
export const paginatedSharedProductPageReducer = paginatedSharedProductPage.reducer;
export default paginatedSharedProductPageReducer

export const paginatedSharedProductPageSelectors = paginatedSharedProductPage.LF.selectors